import React from 'react';

/**
 * Tiny inline SVG trend line. No axes, no dots (optional end dot).
 * points: number[]
 */
export default function Sparkline({
  points = [],
  width = 96,
  height = 24,
  stroke = 'currentColor',
  fill = 'none',
  strokeWidth = 1.5,
  endDot = true,
  area = false,
  className = '',
}) {
  if (!points || points.length < 2) {
    return (
      <svg width={width} height={height} className={className} aria-hidden>
        <line
          x1={0}
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke="currentColor"
          strokeOpacity={0.15}
          strokeWidth={1}
        />
      </svg>
    );
  }

  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const stepX = width / (points.length - 1);
  const pad = 2;
  const coords = points.map((p, i) => {
    const x = i * stepX;
    const y = pad + (height - pad * 2) * (1 - (p - min) / span);
    return [x, y];
  });
  const d = coords
    .map(([x, y], i) => (i === 0 ? `M ${x.toFixed(2)} ${y.toFixed(2)}` : `L ${x.toFixed(2)} ${y.toFixed(2)}`))
    .join(' ');
  const areaD = area
    ? `${d} L ${width.toFixed(2)} ${(height - pad).toFixed(2)} L 0 ${(height - pad).toFixed(2)} Z`
    : null;
  const [lx, ly] = coords[coords.length - 1];

  return (
    <svg width={width} height={height} className={className} aria-hidden>
      {areaD && <path d={areaD} fill={stroke} fillOpacity={0.08} />}
      <path d={d} fill={fill} stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      {endDot && <circle cx={lx} cy={ly} r={2} fill={stroke} />}
    </svg>
  );
}
